import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggle, MatButtonToggleGroup } from '@angular/material/button-toggle';

import { ErrorTooltipDirective } from '~core/directives/error-tooltip.directive';
import { ButtonToggleModel } from '~core/models/button-toggle.model';

@Component({
    selector: 'arc-button-toggle-group',
    templateUrl: './button-toggle-group.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [MatButtonToggleGroup, ErrorTooltipDirective, ReactiveFormsModule, NgClass, MatButtonToggle]
})
export class ButtonToggleGroupComponent<T> {
    items = input.required<ButtonToggleModel<T>[]>();
    control = input.required<FormControl>();
    toggleButtonClasses = input<string>();
    toggleGroupClasses = input<string>();
}
